import * as actionTypes from 'actions';

const initialState = {
  themeMode: 'light',
};

const themeReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SWITCH_THEME_MODE: {
      return {
        ...state,
        themeMode: action.mode,
      };
    }
    default: {
      return state;
    }
  }
};

export default themeReducer;
